import { isFuture } from 'date-fns';
import { LoadingState } from '../../types/loading-state';
import { logger } from '../logger';
/**
 * Check if an item has been successfully loaded and hasn't expired.
 *
 * @param {FetchedData<T> | undefined} fetchedData
 * @param description
 * @returns {boolean}
 */
export const isFetchedDataValid = (fetchedData, description) => {
    if ((fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.loadingState) !== LoadingState.Success)
        return false;
    const isValid = isFuture(new Date(fetchedData.expiresAt));
    if (isValid && description) {
        logger.debug(`${description}: cache valid until ${fetchedData.expiresAt}`);
    }
    return isValid;
};
